import { useFormContext } from 'react-hook-form';
import { CONFIG_OVERRIDE_LABELS } from '#components/patterns/config-overrides/labels/ConfigOverrideLabels.ts';
import { Field } from '#components/patterns/forms/field/Field.tsx';
import type { ConfigOverride } from '#dn-types/host.ts';
import type { OverrideFormData, OverrideFormTransformedData } from '../form-data.ts';
import { makeOnSubmit } from './submit.ts';

type FormData = OverrideFormData[keyof OverrideFormData];
type FormDataTransformed = OverrideFormTransformedData[keyof OverrideFormData];
type overrideKey = Extends<
  ConfigOverride['key'],
  | 'definednet.dns.resolver_addrs'
  | 'definednet.dns.match_domains'
  | 'definednet.dns.search_domains'
  | 'lighthouse.advertise_addrs'
  | 'lighthouse.interval'
  | 'preferred_ranges'
  | 'listen.host'
  | 'tun.disabled'
  | 'tun.dev'
  | 'tun.mtu'
  | 'tun.tx_queue'
  | 'tun.use_offloads'
  | 'listen.batch'
  | 'listen.read_buffer'
  | 'listen.write_buffer'
  | 'listen.udp_offloads'
  | 'routines'
  | 'logging.level'
  | 'logging.format'
  | 'logging.timestamp_format'
  | 'static_map.network'
  | 'punchy.delay'
  | 'punchy.respond_delay'
>;

type Props = {
  overrideKey: overrideKey;
  onSave: (overrides: ConfigOverride[]) => void;
  children: React.ReactNode;
  noLabel?: boolean;
};

export function SingleConfigForm({ children, overrideKey, noLabel, onSave }: Props) {
  const formContext = useFormContext<FormData, unknown, FormDataTransformed>();
  const { handleSubmit } = formContext;

  const onSubmit = makeOnSubmit(handleSubmit, onSave);

  return (
    <form method="post" id={`${overrideKey}-form`} onSubmit={onSubmit}>
      {noLabel ? children : <Field label={CONFIG_OVERRIDE_LABELS[overrideKey]}>{children}</Field>}
    </form>
  );
}

// Helper for extending a union
type Extends<T, U extends T> = U;
